import { css, keyframes } from "styled-components";

export const loadingSkeleton = (
  iteration = "infinite",
  duration = "3s",
  timing = "ease-in-out"
) => {
  const loadingAnimation = keyframes`
    0% {
      background-color: #f0f0f1;
    }
    50% {
      background-color: #DCDCDD;
    }
    100% {
      background-color: #f0f0f1;
    }
  `;

  return css`
    animation: ${loadingAnimation} ${duration} ${iteration} ${timing};
  `;
};
